import {
  FETCH_RESOURCE_REQUEST,
  FETCH_RESOURCE_SUCCESS,
  FETCH_RESOURCE_FAILURE
} from '../../actionTypes/resourceActionTypes'

import { decodeHtmlEntities } from '../../helpers/decodeHtmlEntities'

const initialState = {
  data: {},
  meta: {}
}

const stateReducer = oldState => (oldAccumulator, newResource) => {
  const { id, type, attributes } = newResource
  const updatedNewResource = {
    ...newResource,
    attributes: {
      ...attributes,
      name: attributes.name ? decodeHtmlEntities(attributes.name) : attributes.name
    }
  }
  const oldData = oldState[type] || {}
  const newData = {
    ...oldData,
    [id]: updatedNewResource
  }
  const newAccumulator = {
    ...oldAccumulator,
    [type]: {
      ...oldAccumulator[type],
      ...newData
    }
  }

  return newAccumulator
}

const buildRequestState = (oldState, payload) => {
  const partNumber = payload
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const newState = {
    ...oldState,
    data: {
      ...oldData
    },
    meta: {
      ...oldMeta,
      [partNumber]: {
        ...oldMeta[partNumber],
        requestDone: false,
        errorDetail: ''
      }
    }
  }
  return newState
}

const buildSuccessState = (oldState, payload) => {
  const { partNumber, data, meta } = payload
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const reducer = stateReducer(oldState)
  const updates = data.reduce(reducer, {})
  const newState = {
    ...oldState,
    data: {
      ...oldData,
      [partNumber]: {
        ...oldData[partNumber],
        ...updates,
        badgesPriority: meta?.priority
      }
    },
    meta: {
      ...oldMeta,
      [partNumber]: {
        ...oldMeta[partNumber],
        errorDetail: '',
        requestDone: true
      }
    }
  }
  return newState
}

const buildFailureState = (oldState, payload) => {
  const { partNumber, errorDetail } = payload
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const newState = {
    ...oldState,
    data: {
      ...oldData,
      [partNumber]: {
        ...oldData[partNumber]
      }
    },
    meta: {
      ...oldMeta,
      [partNumber]: {
        ...oldMeta[partNumber],
        errorDetail,
        requestDone: true
      }
    }
  }
  return newState
}

const resourceReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_RESOURCE_REQUEST:
      return buildRequestState(state, payload)
    case FETCH_RESOURCE_SUCCESS:
      return buildSuccessState(state, payload)
    case FETCH_RESOURCE_FAILURE:
      return buildFailureState(state, payload)
    default:
      return state
  }
}

export { initialState, resourceReducer }
